<app-modal-frame [headerText]="modalHeader" (emitExit)="onExit()">
  <!-- Pull out into own component -->
  @if (modalStatus === FORM_STATUS.ADD || modalStatus === FORM_STATUS.EDIT) {
    <form [formGroup]="userProfileForm" class="card-content">
      <!-- First Row -->
      <ion-row class="wrapper">
        <!-- Employee Id-->
        <ion-col
          size="4"
          [ngClass]="{ 'disabled-input ': modalStatus === FORM_STATUS.EDIT }"
        >
          <app-form-text-field
            [labelText]="CONST.LABELS.EMPLOYEE_ID"
            [maxLength]="15"
            [minLength]="7"
            [form]="userProfileForm"
            [regexType]="CHARS.ALPHABET_NUMBER_NO_SPACE"
            [required]="true"
            [control]="IDS.EMPLOYEE_ID"
            [placeholderText]="CONST.PLACEHOLDER.EMPLOYEE_ID"
            [autoCapitalizeCharacters]="true"
            (paste)="commonUtils.sanitizePaste($event, 'alphanumeric')"
          ></app-form-text-field>
        </ion-col>

        <!-- User Id-->
        <ion-col
          size="4"
          [ngClass]="{ 'disabled-input ': modalStatus === FORM_STATUS.EDIT }"
        >
          <app-form-text-field
            [labelText]="CONST.LABELS.USERID"
            [maxLength]="10"
            [minLength]="7"
            [form]="userProfileForm"
            [regexType]="CHARS.ALPHABET_NUMBER_NO_SPACE"
            [control]="IDS.USER_ID"
            [placeholderText]="CONST.PLACEHOLDER.USERID"
            [autoCapitalizeCharacters]="true"
            (ionBlur)="trim(IDS.USER_ID)"
            (paste)="commonUtils.sanitizePaste($event, 'alphanumeric')"
          ></app-form-text-field>
        </ion-col>

        <!-- Email -->
        <ion-col
          size="4"
          [ngClass]="{ 'disabled-input ': modalStatus === FORM_STATUS.EDIT }"
        >
          <app-form-text-field
            [labelText]="CONST.LABELS.EMAIL"
            [maxLength]="80"
            [form]="userProfileForm"
            [regexType]="CHARS.EMAIL"
            [control]="IDS.EMAIL"
            [placeholderText]="CONST.PLACEHOLDER.EMAIL"
            (ionBlur)="trim(IDS.EMAIL)"
            (paste)="commonUtils.sanitizePaste($event, 'emailSafe')"
          ></app-form-text-field>
        </ion-col>
      </ion-row>

      <!-- Second Row-->
      <ion-row class="wrapper">
        <!-- Last Name-->
        <ion-col size="4">
          <app-form-text-field
            [labelText]="CONST.LABELS.LAST_NAME"
            [maxLength]="30"
            [form]="userProfileForm"
            [regexType]="CHARS.ALPHA_SPACE_DASH"
            [control]="IDS.LAST_NAME"
            [placeholderText]="CONST.PLACEHOLDER.LAST_NAME"
            (ionBlur)="trim(IDS.LAST_NAME)"
            (paste)="
              commonUtils.sanitizePaste($event, 'alphabetWithSpaceAndDash')
            "
          ></app-form-text-field>
        </ion-col>

        <!-- First Name -->
        <ion-col size="4">
          <app-form-text-field
            [labelText]="CONST.LABELS.FIRST_NAME"
            [maxLength]="30"
            [form]="userProfileForm"
            [regexType]="CHARS.ALPHA_SPACE_DASH"
            [control]="IDS.FIRST_NAME"
            [placeholderText]="CONST.PLACEHOLDER.FIRST_NAME"
            (ionBlur)="trim(IDS.FIRST_NAME)"
            (paste)="
              commonUtils.sanitizePaste($event, 'alphabetWithSpaceAndDash')
            "
          ></app-form-text-field>
        </ion-col>

        <!-- User Role -->
        <ion-col size="4">
          <app-form-select
            [label]="CONST.LABELS.USER_ROLE"
            [options]="roleOptions"
            [formControlName]="IDS.USER_ROLE"
            [required]="!userProfileForm.get(IDS.USER_ROLE)?.disabled"
            [isDisabled]="isUserRoleDisabled"
            [hasAltHeight]="true"
          ></app-form-select>
        </ion-col>
      </ion-row>

      <!-- Third Row -->
      <ion-row class="wrapper">
        <!-- Group-->
        <ion-col size="3">
          <app-form-select
            [label]="CONST.LABELS.GROUP"
            [options]="locationGroups"
            [formControlName]="IDS.GROUP"
            [required]="true"
            [hasAltHeight]="true"
            [dropdownPosition]="DropdownPosition.TOP"
            [isDisabled]="canEditGroup"
            (update)="updateLinkedSites()"
          ></app-form-select>
        </ion-col>

        <!-- Location -->
        <ion-col size="3">
          <app-form-select
            [label]="CONST.LABELS.LOCATION"
            [options]="linkedSites"
            [formControlName]="IDS.LOCATION"
            [required]="true"
            [hasAltHeight]="true"
            [isDisabled]="canEditLocation"
            [dropdownPosition]="DropdownPosition.TOP"
          ></app-form-select>
        </ion-col>

        <!-- Language -->
        <ion-col size="3">
          <app-form-select
            [label]="CONST.LABELS.LANGUAGE"
            [options]="LANGS"
            [formControlName]="IDS.LANGUAGE"
            [required]="true"
            [hasAltHeight]="true"
            [dropdownPosition]="DropdownPosition.TOP"
          ></app-form-select>
        </ion-col>

        <!-- Active -->
        <ion-col size="3">
          <app-form-select
            [label]="CONST.LABELS.ACTIVE"
            [options]="USER_OPTIONS"
            [formControlName]="IDS.ACTIVE"
            [required]="true"
            [hasAltHeight]="true"
            [hasSmallSelect]="true"
          ></app-form-select>
        </ion-col>
      </ion-row>
    </form>
  }

  <!-- Pull out into own component -->
  @if (
    modalStatus === FORM_STATUS.VIEW || modalStatus === FORM_STATUS.VIEW_EDIT
  ) {
    <div class="card-content">
      <!-- Row 1-->
      <ion-row class="wrapper">
        <!-- Employee ID -->
        <ion-col size="4">
          <div class="profile-headers">{{ CONST.LABELS.EMPLOYEE_ID }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.EMPLOYEE_ID)?.value }}
          </div>
        </ion-col>

        <!-- User ID -->
        <ion-col size="4">
          <div class="profile-headers">{{ CONST.LABELS.USERID }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.USER_ID)?.value }}
          </div>
        </ion-col>

        <!-- Email -->
        <ion-col size="4">
          <div class="profile-headers">{{ CONST.LABELS.EMAIL }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.EMAIL)?.value }}
          </div>
        </ion-col>
      </ion-row>

      <!-- Row 2-->
      <ion-row class="wrapper">
        <!-- Last Name-->
        <ion-col size="4">
          <div class="profile-headers">{{ CONST.LABELS.LAST_NAME }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.LAST_NAME)?.value }}
          </div>
        </ion-col>

        <!-- First Name -->
        <ion-col size="4">
          <div class="profile-headers">{{ CONST.LABELS.FIRST_NAME }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.FIRST_NAME)?.value }}
          </div>
        </ion-col>

        <!-- User Role -->
        <ion-col size="4">
          <div class="profile-headers">{{ CONST.LABELS.USER_ROLE }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.USER_ROLE)?.value }}
          </div>
        </ion-col>
      </ion-row>

      <!-- Row 3-->
      <ion-row class="wrapper">
        <!-- Group -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.GROUP }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.GROUP)?.value }}
          </div>
        </ion-col>

        <!-- Location -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.LOCATION }}</div>
          <div class="profile-values">
            {{ userProfileForm.get(IDS.LOCATION)?.value }}
          </div>
        </ion-col>

        <!-- Language -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.LANGUAGE }}</div>
          <div class="profile-values">
            {{ viewLanguage }}
          </div>
        </ion-col>

        <!-- Active User -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.ACTIVE }}</div>
          <div class="profile-values">
            @switch (userProfileForm.get(IDS.ACTIVE)?.value) {
              @case (IMAGE_OPTIONS.ACTIVE) {
                <div class="option">
                  <img
                    class="select-icons active-icon"
                    [src]="IMAGES.ACTIVE"
                    alt="active"
                  />
                </div>
              }
              @case (IMAGE_OPTIONS.DEACTIVATED) {
                <div class="option">
                  <img
                    class="select-icons deactivated-icon"
                    [src]="IMAGES.CANCEL"
                    alt="cancel"
                  />
                </div>
              }
              @default {
                {{ userProfileForm.get(IDS.ACTIVE)?.value }}
              }
            }
          </div>
        </ion-col>
      </ion-row>
    </div>
  }

  <ion-row class="footer-row">
    <!-- For User Admin Screen Edit/Add-->
    @if (
      disableEmailRole &&
      (modalStatus === FORM_STATUS.ADD || modalStatus === FORM_STATUS.EDIT)
    ) {
      <ion-col size="2">
        <ion-button
          class="reset-button"
          fill="outline"
          size="default"
          id="button-text"
          (click)="initializeForm()"
          onkeypress="initializeForm()"
          [disabled]="userProfileForm.pristine"
          [ngClass]="{ 'is-disabled': userProfileForm.pristine }"
        >
          {{ CONST.BUTTONS.RESET }}
        </ion-button>
      </ion-col>

      <ion-col offset="8" size="2">
        @if (showButton) {
          <ion-button
            class="continue-button"
            id="button-text"
            size="default"
            (click)="onButtonClick()"
            onkeypress="onButtonClick()"
            [disabled]="isButtonDisabled"
            [ngClass]="{ 'is-disabled': isButtonDisabled }"
          >
            {{ CONST.BUTTONS.SAVE }}
          </ion-button>
        }
      </ion-col>
    }
    <!---->

    @if (modalStatus === FORM_STATUS.VIEW_EDIT) {
      <ion-col offset="8" size="2">
        <ion-button
          id="button-text"
          class="edit-button"
          size="default"
          onkeypress="onButtonClick()"
          (click)="onButtonClick()"
          [disabled]="isButtonDisabled"
          [ngClass]="{ 'is-disabled': isButtonDisabled }"
        >
          <ion-icon
            class="icon"
            slot="icon-only"
            [src]="IMAGES.EDIT_WHITE"
          ></ion-icon>
        </ion-button>
      </ion-col>
    }

    <!-- For My Profile-->
    @if (!disableEmailRole && modalStatus === FORM_STATUS.EDIT) {
      <ion-col offset="8" size="2">
        <ion-button
          class="save-button"
          size="default"
          id="button-text"
          (click)="onButtonClick()"
          onkeypress="onButtonClick()"
          [disabled]="isButtonDisabled"
          [ngClass]="{ 'is-disabled': isButtonDisabled }"
        >
          <ion-icon
            class="icon icon-save"
            slot="icon-only"
            [src]="IMAGES.SAVE_ON"
          ></ion-icon>
        </ion-button>
      </ion-col>
    }
    <!---->
  </ion-row>
</app-modal-frame>
